import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReducerStateType } from './types';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'joinedOn',
  clearPage: true
} as ReducerStateType;

export const syndicateListingSlice = createSlice({
  name: 'syndicateListing',
  initialState,
  reducers: {
    resetSyndicateListingValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'joinedOn'
    }),
    updateSyndicateListingValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    updateSyndicateListingClearPage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => ({
      ...state,
      clearPage: payload
    })
  }
});

export const {
  resetSyndicateListingValues,
  updateSyndicateListingValues,
  updateSyndicateListingClearPage
} = syndicateListingSlice.actions;

export default syndicateListingSlice.reducer;
